import { render, staticRenderFns } from "./LatestSection.vue?vue&type=template&id=604d33da&scoped=true"
import script from "./LatestSection.vue?vue&type=script&lang=js"
export * from "./LatestSection.vue?vue&type=script&lang=js"
import style0 from "./LatestSection.vue?vue&type=style&index=0&id=604d33da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d33da",
  null
  
)

export default component.exports